<template>
  <div
    class="rightSection"
    :style="customSearchDisplay"
    style="flex-wrap: wrap"
  >
    <slot name="quickFilter"></slot>
    <div
      :class="['searchBox fix-width__medium ', customClass]"
      :style="width ? 'width:' + width : ''"
    >
      <i
        class="fas fa-search color__silver"
        style="cursor: pointer"
        @click="$emit('simpleSearch', keyword_)"
      ></i>
      <el-input
        :title="placeholder ? placeholder : 'Nhập từ khoá'"
        class="input-border__bottom input-border__radius__0"
        v-model="keyword_"
        size="medium"
        :placeholder="placeholder ? placeholder : 'Nhập từ khoá'"
        @keydown.enter.exact.native="$emit('simpleSearch', keyword_)"
      />
      <el-tooltip
        content="Tìm kiếm nâng cao"
        placement="top"
        slot="reference"
        v-if="!isDisableAdvanceSearch"
      >
        <i
          class="fas fa-filter clickable color__blue"
          @click="$emit('search', keyword_)"
        ></i>
      </el-tooltip>
    </div>
    <slot name="advance" v-if="!isDisableAdvanceSearch"></slot>
  </div>
</template>

<script>
export default {
  name: "search",
  props: [
    "keyword",
    "isDisableAdvanceSearch",
    "customStyle",
    "customSearchDisplay",
    "placeholder",
    "customClass",
    "width",
  ],
  data() {
    return {
      keyword_: "",
    };
  },
  created() {
    this.keyword_ = this.keyword;
    this.customStyle_ = this.customStyle;
  },
  watch: {
    keyword(newValue) {
      this.keyword_ = newValue;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/search.vue